<template>
  <div v-loading="loading">
    <FormBox
      :title="$t('hzmbChange.title.owner_data')"
      style="background: #fff"
    >
      <el-form
        ref="ruleForm"
        :model="form.quota"
        class="form_type1_box"
        :rules="quotaRules"
        hide-required-asterisk
      >
        <el-row :gutter="86" type="flex">
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('hzmbChange.label.spNo')">
              <el-input v-model="form.caseNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="
                isGHCompany
                  ? $t('hzmbChange.label.registrationNo')
                  : $t('hzmbChange.label.quotaRegistrationNo')
              "
            >
              <el-input
                v-model="form.quota.quotaRegistrationNo"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <template v-if="applicantType == 'PERSON'">
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.personal_idType')"
                prop="applicantIdentType"
              >
                <el-select
                  v-model="form.quota.applicantIdentType"
                  value-key="codeKey"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="item in idType"
                    :key="item.codeKey"
                    :label="item[`${$t('message.codeName')}`]"
                    :value="item.codeKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbChange.label.personIdentityNo')">
                <el-input
                  v-model="form.quota.applicantIdentNo"
                  :placeholder="$t('hzmbChange.message.personIdentityNo_plh')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.personNameCn')"
                prop="applicantCname"
              >
                <el-input
                  v-model="form.quota.applicantCname"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.personNameEn')"
                prop="applicantEname"
              >
                <el-input
                  v-model="form.quota.applicantEname"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.personBirthday')"
                prop="birthday"
              >
                <el-date-picker
                  v-model="form.quota.birthday"
                  type="date"
                  :placeholder="$t('hzmbChange.message.personBirthday_plh')"
                  :picker-options="beforeToday"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12"></el-col>
          </template>
          <!-- COMPANY -->
          <template v-if="applicantType == 'COMPANY'">
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.macau_company_type')"
                prop="companyIdentityType"
              >
                <el-select
                  v-model="form.quota.companyIdentityType"
                  :placeholder="$t('hzmbChange.message.macau_company_type_plh')"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="item in companyType"
                    :key="item.code"
                    :label="item.label"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.companyBrNo')"
                prop="companyBrNo"
              >
                <el-input
                  v-model="form.quota.companyBrNo"
                  :placeholder="$t('hzmbChange.message.companyBrNo_plh')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.companyNameCn')"
                prop="companyNameCn"
              >
                <el-input
                  v-model="form.quota.companyNameCn"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbChange.label.companyNameEn')"
                prop="companyNameEn"
              >
                <el-input
                  v-model="form.quota.companyNameEn"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </template>
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="
                isCompany
                  ? $t('hzmbChange.label.company_applicantMobile')
                  : $t('hzmbChange.label.personMacauMobile')
              "
              prop="applicantMobile"
            >
              <el-input
                v-model="form.quota.applicantMobile"
                :placeholder="
                  isCompany
                    ? $t('hzmbChange.message.company_applicantMobile')
                    : $t('hzmbChange.message.personal_macauMobile_plh')
                "
                class="input-with-select"
                maxlength="8"
              >
                <template slot="prepend">+853</template>
              </el-input>
            </el-form-item>
            <div :class="`tips_red tips_red_${$i18n.locale}`">
              {{ $t("hzmbChange.message.applicantMobileTips") }}
            </div>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="
                isCompany
                  ? $t('hzmbChange.label.company_macauAddress')
                  : $t('hzmbChange.label.personMacauAddress')
              "
              prop="macauAddress.textCn"
              :rules="[
                {
                  required: true,
                  message: $t('hzmbChange.message.notNull'),
                },
                {
                  pattern: /^.{5,}$/,
                  message: $t('hzmbChange.message.addressMin'),
                },
              ]"
            >
              <el-input
                ref="macauAddressInput"
                v-model="form.quota.macauAddress.textCn"
                :placeholder="
                  isCompany
                    ? $t('hzmbChange.message.company_macauAddress')
                    : $t('hzmbChange.message.macauAddress_plh')
                "
                @focus="onAddressFocus"
              ></el-input>
            </el-form-item>
          </el-col>
          <template v-if="!isGHCompany">
            <el-col :xs="24" :sm="12" style="align-self: flex-start;">
              <el-form-item
                :label="
                  isCompany
                    ? $t('hzmbChange.label.company_mainlandPhone')
                    : $t('hzmbChange.label.personMainlandPhone')
                "
                prop="mainlandPhone"
              >
                <el-input
                  v-model="form.quota.mainlandPhone"
                  :placeholder="
                    isCompany
                      ? $t('hzmbChange.message.company_mainlandPhone')
                      : $t('hzmbChange.message.personal_mainlandPhone_plh')
                  "
                  maxlength="11"
                >
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="
                  isCompany
                    ? $t('hzmbChange.label.company_mainlandEmail')
                    : $t('hzmbChange.label.personMainlandEmail')
                "
                prop="mainlandEmail"
              >
                <el-input
                  v-model="form.quota.mainlandEmail"
                  :placeholder="
                    isCompany
                      ? $t('hzmbChange.message.company_mainlandEmail')
                      : $t('hzmbChange.message.personal_mainlandEmail_plh')
                  "
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="confirmMainlandEmail"
                :rules="[
                  { validator: confirmEmailCheck, trigger: 'blur' },
                  {
                    type: 'email',
                    message: $t('message.formRuleMessage.email'),
                    trigger: ['blur'],
                  },
                ]"
              >
                <el-input
                  id="emailConfirm"
                  v-model="form.quota.confirmMainlandEmail"
                  maxlength="50"
                  :placeholder="$t('hzmbChange.message.email_confirm')"
                  @focus="onEmailConfirmInput"
                ></el-input>
              </el-form-item>
            </el-col>
          </template>
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="
                isCompany
                  ? $t('hzmbChange.label.company_hkPhone')
                  : $t('hzmbChange.label.personHkPhone')
              "
              prop="hkPhone"
              :rules="[
                {
                  required: !['E01', 'E03', 'F01', 'F03'].includes(
                    form.hzmbSubtype
                  ),
                  message: $t('hzmbChange.message.notNull'),
                },
                {
                  max: 26,
                  message: $t('hzmbChange.message.maxLength', [26]),
                  trigger: 'blur',
                },
                {
                  pattern: /^[\d\-]+$/,
                  message: $t('hzmbChange.message.hkPhoneCheck'),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="form.quota.hkPhone"
                :placeholder="
                  isCompany
                    ? $t('hzmbChange.message.company_hkPhone')
                    : $t('hzmbChange.message.personal_hkPhone_plh')
                "
              >
                <template slot="prepend">+852</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="!isGHCompany" :xs="24" :sm="24">
            <el-form-item
              :label="
                isCompany
                  ? $t('hzmbChange.label.company_hkAddress')
                  : $t('hzmbChange.label.personHkAddress')
              "
              prop="hkAddress"
            >
              <el-input
                v-model="form.quota.hkAddress"
                :placeholder="
                  isCompany
                    ? $t('hzmbChange.message.company_hkAddress')
                    : $t('hzmbChange.message.personal_hkAddress_plh')
                "
                @input="inputToUpperCase($event, 'hkAddress')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </FormBox>
    <MacauAddressDialog
      :visible="showAddressDialog"
      @save="saveMacauAddress"
      @close="showAddressDialog = false"
    ></MacauAddressDialog>
  </div>
</template>
  
  <script>
import i18n from "/public/lang/index";
import VssViewAPI from "@/api/VssViewAPI";
import FormBox from "../../../components/FormBox.vue";
import MacauAddressDialog from "../../../components/MacauAddressDialog.vue";
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          quota: {
            macauAddress: {},
          },
        };
      },
    },
    applicantType: String,
    vssForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { FormBox, MacauAddressDialog },
  data() {
    let validcodeMacauMobile = (rule, value, callback) => {
      // 驗證澳門手機
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("hzmbChange.message.macauMobile")));
      } else {
        callback();
      }
    };
    let olderThan18 = (rule, value, callback) => {
      const birthdays = new Date(value) || value;
      let d = new Date();
      let age = null;
      if (birthdays) {
        age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
            ? 1
            : 0);
      }
      if (value && age < 18) {
        callback(new Error(i18n.t("hzmbChange.message.mustAdult")));
      } else {
        callback();
      }
    };
    let macauAddressCheck = (rule, value, callback) => {
      const quota = this.form.quota;
      if (
        value == "other" &&
        !(quota && quota.macauAddress && quota.macauAddress.textCn)
      ) {
        callback(new Error(i18n.t("hzmbChange.message.notNull")));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      beforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天
        },
      },
      quotaRules: {
        applicantIdentNo: [
          {
            max: 50,
            message: i18n.t("hzmbChange.message.maxLength", [50]),
            trigger: "blur",
          },
        ],
        birthday: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          { validator: olderThan18, trigger: "change" },
          { validator: olderThan18, trigger: "blur" },
        ],
        companyBrNo: [
          {
            max: 50,
            message: i18n.t("hzmbChange.message.maxLength", [50]),
            trigger: "blur",
          },
        ],
        hkAddress: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 200,
            message: i18n.t("hzmbChange.message.maxLength", [200]),
            trigger: "blur",
          },
        ],
        mainlandPhone: [
          {
            pattern: /^[\d]+$/,
            message: i18n.t("hzmbChange.message.mainlandPhoneCheck"),
            trigger: "blur",
          },
        ],
        mainlandEmail: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
          {
            pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/,
            message: i18n.t("hzmbChange.message.emailCheck"),
            trigger: "blur",
          },
          {
            max: 50,
            message: i18n.t("hzmbChange.message.maxLength", [50]),
            trigger: "blur",
          },
        ],
        vssMacauAddress: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "change",
          },
          { validator: macauAddressCheck },
        ],
        applicantMobile: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          { validator: validcodeMacauMobile, trigger: "blur" },
          {
            max: 30,
            message: i18n.t("hzmbChange.message.maxLength", [30]),
            trigger: "blur",
          },
        ],
      },
      idType: [],
      companyType: [
        {
          code: "CO",
          label: i18n.t("hzmbChange.enum.companyType.CO"),
        },
        {
          code: "EM",
          label: i18n.t("hzmbChange.enum.companyType.EM"),
        },
        {
          code: "SO",
          label: i18n.t("hzmbChange.enum.companyType.SO"),
        },
      ],
      showAddressDialog: false,
    };
  },
  computed: {
    serviceType() {
      return this.$route.params.serviceType;
    },
    isCompany() {
      return this.applicantType === "COMPANY";
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
  },
  methods: {
    confirmEmailCheck(rule, value, callback) {
      const { mainlandEmail: email } = this.form.quota;
      if (!value && email) {
        callback(new Error(i18n.t("hzmbChange.message.email_confirm")));
      } else if (email && value !== email) {
        callback(new Error(i18n.t("hzmbChange.message.emial_confirm_tip")));
      } else {
        callback();
      }
    },
    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    // 打開澳門地址填寫彈窗
    onAddressFocus() {
      this.$refs["macauAddressInput"].blur();
      this.showAddressDialog = true;
    },
    // 儲存澳門地址回調
    saveMacauAddress(val) {
      this.showAddressDialog = false;
      this.form.quota.macauAddress = val;
    },
    // 修改澳門地址
    changeVssMacauAddress(val) {
      if (val != "other") {
        const macauAddress = {
          textCn: val,
        };
        this.$set(this.form.quota, "macauAddress", macauAddress);
      }
    },
    // 獲取證件類別
    getIdentityTypes() {
      this.loading = true;
      VssViewAPI.getIdentityTypes()
        .then((res) => {
          this.loading = false;
          this.idType = res;
          this.$set(this.form.quota, "applicantIdentType", "BM");
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, name) {
      this.form.quota[name] = val.toUpperCase();
    },
    // 再次確認電子郵件欄位禁止粘貼
    onEmailConfirmInput() {
      let email = document.getElementById("emailConfirm");
      email.onpaste = () => {
        console.log("觸發粘貼");
        return false;
      };
    },
  },
  created() {
    // 獲取證件類別
    if (this.serviceType == "HZMB_CHANGE_PERSON") {
      this.getIdentityTypes();
    }
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/.el-radio-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
  width: 100%;
  .el-radio {
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: pre-wrap;
    line-height: 22px;
  }
  .el-radio__label {
    font-size: 16px;
  }
  .el-radio__inner {
    width: 16px;
    height: 16px;
  }
}
</style>